import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectAddressByOfferId } from '../../../../../../selectors/address';
import { TextField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const AddressFieldContainer: React.VFC = () => {
  const { id, published } = useOfferContext();
  const address = useSelector(selectAddressByOfferId(id));

  return <TextField published={published}>{address}</TextField>;
};
